import { useRouter } from 'next/router';

import { useQuery } from 'react-query';
import { CategoriesService } from 'services/core';

import EmptyIcon from 'assets/icons/element-cross.svg';

import classes from './CategoryEmptyPage.module.scss';

const CategoryEmptyPage = () => {
	const { data } = useQuery(['categories-home-page'], CategoriesService);

	const router = useRouter();

	return (
		<section
			className={`${classes['empty-categories-container']} container d-flex flex-column align-items-center justify-content-center my-3 my-md-5`}>
			<EmptyIcon />
			<h5>This category is not yet ready.</h5>
			<hr className={`${classes['divider']}`}></hr>
			<h5>Try top categories</h5>
			<div className={`${classes['category-section']} container`}>
				{((data?.data?.results && data?.data.results.slice(0, 5)) || []).map((item) => (
					<button
						onClick={() => router.push(`/category/${item.id}`)}
						key={item.id}
						className={classes['category-item']}>
						<img src={item.image} alt={item.name} style={{ backgroundColor: item.color + 20 }} />
						<div>{item.name}</div>
					</button>
				))}
			</div>
		</section>
	);
};

export default CategoryEmptyPage;
